import { translations, defaultLocale } from './translations';

function getUrlLanguage() {
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    return translations[langParam] ? langParam : null;
}

function getBrowserLanguage() {
    if (!window.navigator) return null;

    const languages = window.navigator.languages || [
        window.navigator.language || 
        window.navigator.browserLanguage || 
        window.navigator.userLanguage
    ];

    // Try to find exact match first
    for (const lang of languages) {
        const shortLang = lang.split('-')[0]; // Convert 'es-ES' to 'es'
        if (translations[shortLang]) {
            return shortLang;
        }
    }

    return null;
}

export function detectLanguage() {
    // Priority 1: URL parameter
    const urlLang = getUrlLanguage();
    if (urlLang) return urlLang;

    // Priority 2: Browser language
    const browserLang = getBrowserLanguage();
    if (browserLang) return browserLang;

    // Priority 3: Default locale
    return defaultLocale;
} 